import { FC } from 'react';

type Props = {
    className?: string;
};

const FireIconSolid: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="#2B2B2B"
            stroke="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.99567 1.09181C8.80258 1.00927 8.58092 1.02921 8.40567 1.14489C8.23045 1.26056 8.125 1.45652 8.125 1.66651C8.125 3.41821 7.00496 4.72318 5.77547 6.1556C4.51853 7.62202 3.125 9.33759 3.125 12.0832C3.125 15.8802 6.20304 18.9582 10 18.9582C13.7969 18.9582 16.875 15.8802 16.875 12.0832C16.875 11.1831 16.8644 9.35067 15.0714 7.10941C14.9081 6.90526 14.6349 6.82434 14.3867 6.90656C14.1387 6.98873 13.968 7.21671 13.9587 7.47782C13.9295 7.66739 13.8458 8.19451 13.758 8.4085C13.6679 8.62801 13.5606 8.77617 13.4507 8.85634C13.3646 8.91926 13.2338 8.97451 12.9831 8.92209C12.7686 8.87726 12.6603 8.79826 12.591 8.71667C12.5122 8.62401 12.4406 8.47634 12.3885 8.23253C12.3361 7.98735 12.3122 7.68921 12.298 7.3257C12.2928 7.19432 12.2889 7.04629 12.2847 6.89049C12.2782 6.64853 12.2712 6.38782 12.2587 6.14176C12.2155 5.29836 12.0992 4.32449 11.6319 3.41251C11.1545 2.48054 10.3387 1.66593 8.99567 1.09181ZM9.78933 9.11292C9.77258 8.91742 9.66483 8.74109 9.4985 8.63692C9.33225 8.53267 9.12658 8.51267 8.94333 8.58276C8.14248 8.88926 7.52894 9.62592 7.12943 10.3309C6.72739 11.0404 6.45833 11.8661 6.45833 12.4998C6.45833 13.6683 6.82855 14.6601 7.47729 15.3664C8.12717 16.074 9.02517 16.4592 10 16.4592C12.0931 16.4592 13.5417 14.3451 13.5417 12.0842C13.5417 11.8792 13.4412 11.6872 13.2727 11.5704C13.1042 11.4537 12.8892 11.4269 12.6972 11.4989C12.1157 11.717 11.6803 11.736 11.3571 11.6663C11.0377 11.5973 10.777 11.431 10.5585 11.188C10.1003 10.6785 9.85317 9.85484 9.78933 9.11292Z"
                fill="inherit"
            />
        </svg>
    );
};

export default FireIconSolid;
